import { render, staticRenderFns } from "./reward-record.vue?vue&type=template&id=327eb65c&scoped=true&"
import script from "./reward-record.vue?vue&type=script&lang=js&"
export * from "./reward-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327eb65c",
  null
  
)

export default component.exports